import {Box, Stack, Typography} from "@mui/material";
import {ReactNode} from "react";

type PageHeaderProps = {
  title: string;
  description?: string;
  action?: ReactNode;
};

export const PageHeader = ({title, description, action}: PageHeaderProps) => (
  <Stack
    direction={{xs: "column", sm: "row"}}
    justifyContent="space-between"
    alignItems={{xs: "stretch", sm: "flex-start"}}
    spacing={2}
    sx={{mb: 3}}
  >
    <Box>
      <Typography variant="h5" component="h1" sx={{fontWeight: 700, letterSpacing: "-0.02em"}}>
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, maxWidth: 560}}>
          {description}
        </Typography>
      ) : null}
    </Box>
    {action ? <Box sx={{flexShrink: 0}}>{action}</Box> : null}
  </Stack>
);
